import {data}from "./data.js"

import Main from "../../components/Main/Main.js"


const Venus = () => {
    return (
        <>
        <Main
        planetData={data}
        />
        </>
    )
}

export default Venus